import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api } from '../api.js'
import { useAuth } from '../auth/AuthContext.jsx'

// Teacher: attendance across ALL my courses for one date. Rows can be
// removed here; adding happens on the per-course roster page (linked).

const today = () => new Date().toISOString().slice(0, 10)

export function TeacherAttendanceByDatePage() {
  const { t } = useTranslation()
  const { user, loading: authLoading } = useAuth()
  const [date, setDate] = useState(today())
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [busyId, setBusyId] = useState(null)
  const [error, setError] = useState(null)

  const allowed = user && (user.role === 'teacher' || user.role === 'admin')

  function reload() {
    setLoading(true); setError(null)
    api.teacher.attendance.byDate(date)
      .then((d) => setRows(d.attendances || []))
      .catch((e) => setError(e.code || 'server'))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (authLoading || !allowed) return
    reload()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authLoading, allowed, date])

  async function remove(row) {
    setBusyId(row.id); setError(null)
    try {
      await api.teacher.attendance.remove(row.course_id, { date, enrollment_ids: [row.enrollment_id] })
      reload()
    } catch (e) {
      setError(e.code || 'server')
    } finally { setBusyId(null) }
  }

  if (authLoading) return <main className="container"><p>{t('common.loading')}</p></main>
  if (!allowed) {
    return <main className="container"><p className="error">{t('teacher.errors.not_teacher')}</p></main>
  }

  return (
    <main className="container">
      <p><Link to="/teacher">← {t('teacher.title')}</Link></p>
      <h1>{t('teacher.attendance_by_date')}</h1>
      <p className="muted">{t('teacher.attendance_by_date_intro')}</p>

      <label style={{ maxWidth: '16rem' }}>
        <span>{t('teacher.attendance_date')}</span>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
      </label>

      {error && <p className="error">{t(`teacher.errors.${error}`, { defaultValue: error })}</p>}
      {loading && <p>{t('common.loading')}</p>}
      {!loading && rows.length === 0 && <p className="muted">{t('teacher.attendance_empty')}</p>}

      {!loading && rows.length > 0 && (
        <table className="results-table">
          <thead>
            <tr>
              <th>{t('teacher.col_course')}</th>
              <th>{t('teacher.col_participant')}</th>
              <th>{t('teacher.col_actions')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td><Link to={`/teacher/courses/${r.course_id}/attendance`}>{r.course_name}</Link></td>
                <td>{r.participant_name}</td>
                <td>
                  <button
                    type="button"
                    className="link-button danger"
                    disabled={busyId === r.id}
                    onClick={() => remove(r)}
                  >
                    {t('teacher.remove')}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </main>
  )
}
